import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styled';

function RouteDirectionsTabs({
  directions,
  activeDirection,
  setActiveDirection,
}) {
  return (
    <Styled.RouteDirectionsTabsWrapper>
      <Styled.RouteDirectionsSelectorRow>
        {directions.map(dirData => (
          <Styled.RouteDirectionButton
            key={dirData.dir}
            onClick={() => setActiveDirection(dirData.dir)}
            isActive={activeDirection === dirData.dir}
            direction={dirData.dir}
          >
            {dirData.desc}
          </Styled.RouteDirectionButton>
        ))}
      </Styled.RouteDirectionsSelectorRow>
    </Styled.RouteDirectionsTabsWrapper>
  );
}

RouteDirectionsTabs.propTypes = {
  /** Collection of route directions */
  directions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  /** ID for active direction */
  activeDirection: PropTypes.number,
  /** Function used to set active direction */
  setActiveDirection: PropTypes.func.isRequired,
};

RouteDirectionsTabs.defaultProps = {
  activeDirection: null,
};
export default RouteDirectionsTabs;
